/*eslint-disable*/
import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { getContractAppType } from 'services/api'
import { FormattedMessage } from 'react-intl'
import { accessPage } from 'role'
import styles from './style.module.scss'

const mapStateToProps = ({ menu, contracts }) => ({
  menuData: menu.menuData,
  contracts: contracts, 
})
@connect(mapStateToProps)
class MenuPages extends React.Component {
  menu = () => {
    const { menuData = [] } = this.props
    return (
      <Menu selectable={false} style={{ width: 200 }}>
        {menuData.map(item => {
          if (!accessPage(item.key)) {
            return null
          }
          if (!item.category && item.children) {
            return (
              <Menu.SubMenu
                title={
                  <span>
                    <i className={`${item.icon} mr-2`} />
                    <FormattedMessage id={item.key} />
                  </span>
                }
                key={item.key}
              >
                {item.children.map(subItem => {
                  return (
                    <Menu.Item key={subItem.key}>
                      <Link to={subItem.url}>
                        <FormattedMessage id={subItem.key} />
                      </Link>
                    </Menu.Item>
                  )
                })}
              </Menu.SubMenu>
            )
          }
          if (!item.category && item.url) {
            return (
              <Menu.Item key={item.key}>
                <Link to={item.url}>
                  <i className={`${item.icon} mr-2`} />
                  <FormattedMessage id={item.key} />
                </Link>
              </Menu.Item>
            )
          }
          return null
        })}
      </Menu>
    )
  }
 

  render() {
    return (
      <Dropdown overlay={this.menu} trigger={['click']} placement="bottomLeft">
        <div className={styles.dropdown}>
          <i className={`${styles.icon} fe fe-menu`} />
          <span className="d-none d-lg-inline-block">
            {this.props.contracts && this.props.contracts.selected && this.props.contracts.selected.payload && this.props.contracts.selected.payload.appType === 2 ?
              <FormattedMessage id="general.settings" /> :
              <FormattedMessage id="general.menu" />
            }
          </span>
        </div>
      </Dropdown>
    )
  }
}

export default MenuPages
